import React, { Fragment, useState } from 'react'
import { Button, Dropdown, Tooltip as AntdTooltip, Icon } from 'antd'
import getFileIcon from '../../../utils/getFileIcon'
import { removeFileExtension } from '../../../utils/removeFileExtension'
import AiStatusBadge from '../AiStatusBadge'
import AiLoadingOverlay from '../AiLoadingOverlay'
import FileActionsMenu from '../FileActionsMenu'
import './FileList.scss'
import { border, boxShadow } from 'styled-system'
import { api } from '../../../../../../../services'
import { useTranslation } from 'react-i18next'

const isImage = item =>
  item.media_format === 'IMAGE' ||
  item.media_format === 'PEXEL_IMAGE' ||
  item.media_format === 'GIF' ||
  item.media_format === 'CERT' ||
  item.media_format === 'BADGE' ||
  item.media_format === 'ARIMAGE'

const TableRow = ({
  item,
  isSelected,
  shouldShowCheckbox,
  onCheckboxChange,
  onRowClick,
  onMouseEnter,
  onMouseLeave,
  aiProcessingItems,
  user,
  orgUserList,
  defaultQuery,
  userId,
  isSuperAdmin,
  isAdmin,
  onAction,
  setVersionFile,
  setVersionModalVisible,
  setManagePermissionsModalVisible,
  setAuitModal,
  showActions,
  isImage,
  type,
  openDropdownId,
  setOpenDropdownId,
  isDownloadCenter
}) => {
  const [downloadingMediaId, setDownloadingMediaId] = useState(null)
  const handleDownload = async id => {
    try {
      setDownloadingMediaId(id)

      const response = await api.library.download({ id })
      const { downloadble_link } = response.data

      // Create a hidden <a> element
      const link = document.createElement('a')
      link.href = downloadble_link
      link.download = '' // Leave empty to use filename from server or link
      link.style.display = 'none'
      document.body.appendChild(link)

      // Trigger the download
      link.click()

      // Clean up
      document.body.removeChild(link)
    } catch (error) {
      console.error('Download failed:', error)
    } finally {
      setDownloadingMediaId(null)
    }
  }

  const { t } = useTranslation()

  return (
    <tr
      key={item.id}
      className={`${type}-row${isSelected ? ' selected' : ''}`}
      style={{ position: 'relative' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <AiLoadingOverlay isLoading={aiProcessingItems.has(item.id)} />
      <td style={{ width: 40, position: 'relative' }}>
        <div
          className={`checkbox-wrapper${
            shouldShowCheckbox(item.id) ? ' visible' : ''
          }`}
        >
          <input
            type="checkbox"
            checked={isSelected}
            onClick={e => e.stopPropagation()}
            onChange={onCheckboxChange}
          />
        </div>
      </td>
      <td
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          padding: '16px'
        }}
        onClick={onRowClick}
      >
        {isImage(item) ? (
          <div
            className="item-icon IMAGE"
            style={{
              width: 24,
              height: 24,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              background: '#f4f5fa',
              borderRadius: '6px',
              border: '1px solid #e5e7eb',
              overflow: 'hidden'
            }}
          >
            <img
              src={item.link}
              alt={item.title}
              style={{
                width: 24,
                height: 24,
                objectFit: 'cover',
                borderRadius: '6px',
                display: 'block',
                flexShrink: 0
              }}
              onError={e => (e.target.style.display = 'none')}
            />
          </div>
        ) : (
          <span
            className={`item-icon ${item.media_format}`}
            style={{
              width: 32,
              height: 32,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            {getFileIcon(item.media_format, item.media_mime_type, 'LIST', item)}
          </span>
        )}
        <AntdTooltip
          title={removeFileExtension(item.title, item.media_format)}
          placement="topLeft"
        >
          <span
            style={{
              width: 350,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'inline-block',
              verticalAlign: 'middle',
              flex: 1
            }}
          >
            {removeFileExtension(item.title, item.media_format)}
          </span>
        </AntdTooltip>
      </td>
      <td>
        <AiStatusBadge user={user} item={item} />
      </td>
      <td>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {item?.creator?.avatar ? (
            <img
              className="avatar"
              src={item?.creator?.avatar}
              alt=""
              style={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                objectFit: 'cover',
                background: '#e5e7eb',
                marginRight: 8,
                border: '1px solid #e5e7eb'
              }}
              onError={e => {
                e.target.outerHTML = `
      <i class="anticon anticon-user" 
         style="font-size:32px;color:#999;background:#e5e7eb;border-radius:50%;margin-right:8px;padding:4px;">
        <svg viewBox="64 64 896 896" focusable="false" class="" data-icon="user" width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <path d="M858.5 763.6a374 374 0 0 0-85.7-119.5A374.3 374.3 0 0 0 554 575a373.68 373.68 0 0 0-120 0 374.3 374.3 0 0 0-218.8 69.1A374 374 0 0 0 129.5 763.6 8 8 0 0 0 136 776h752a8 8 0 0 0 6.5-12.4zM512 548c79.5 0 144-64.5 144-144S591.5 260 512 260 368 324.5 368 404s64.5 144 144 144z"></path>
        </svg>
      </i>
    `
              }}
            />
          ) : (
            <i
              class="anticon anticon-user"
              style={{
                fontSize: '32px',
                color: '#999',
                background: '#e5e7eb',
                borderRadius: '50%',
                marginRight: '8px',
                padding: '4px'
              }}
            >
              <svg
                viewBox="64 64 896 896"
                focusable="false"
                class=""
                data-icon="user"
                width="1em"
                height="1em"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M858.5 763.6a374 374 0 0 0-85.7-119.5A374.3 374.3 0 0 0 554 575a373.68 373.68 0 0 0-120 0 374.3 374.3 0 0 0-218.8 69.1A374 374 0 0 0 129.5 763.6 8 8 0 0 0 136 776h752a8 8 0 0 0 6.5-12.4zM512 548c79.5 0 144-64.5 144-144S591.5 260 512 260 368 324.5 368 404s64.5 144 144 144z"></path>
              </svg>
            </i>
          )}
          <span>
            {item.creator && (item.creator.first_name || item.creator.last_name)
              ? `${item.creator.first_name || ''} ${item.creator.last_name ||
                  ''}`.trim()
              : 'N/A'}
          </span>
        </div>
      </td>
      <td>
        {new Date(item.updated_at).toLocaleDateString()},{' '}
        {new Date(item.updated_at).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
      </td>
      <td>
        {showActions && isDownloadCenter && (
          <Button
            type="primary"
            icon="download"
            shape="round"
            loading={downloadingMediaId === item.id}
            onClick={e => {
              e.stopPropagation()
              handleDownload(item.id)
            }}
          >
            {t('buttons:download')}
          </Button>
        )}
        {showActions && !isDownloadCenter && (
          <div className="item-actions">
            <Dropdown
              placement="bottomLeft"
              overlay={() => (
                <FileActionsMenu
                  item={item}
                  user={user}
                  orgUserList={orgUserList}
                  defaultQuery={defaultQuery}
                  userId={userId}
                  isSuperAdmin={isSuperAdmin}
                  isAdmin={isAdmin}
                  aiProcessingItems={aiProcessingItems}
                  onAction={onAction}
                  setVersionFile={setVersionFile}
                  setVersionModalVisible={setVersionModalVisible}
                  setManagePermissionsModalVisible={
                    setManagePermissionsModalVisible
                  }
                  setAuitModal={setAuitModal}
                  closeDropdown={() => setOpenDropdownId(null)}
                />
              )}
              trigger={['click']}
              visible={openDropdownId === item.id}
              onVisibleChange={visible => {
                if (visible) {
                  setOpenDropdownId(item.id)
                } else {
                  setOpenDropdownId(null)
                }
              }}
            >
              <Button
                type="text"
                icon="ellipsis"
                size="small"
                className="filelist-action-btn"
                onClick={function(e) {
                  e.stopPropagation()
                }}
                onMouseDown={function(e) {
                  e.stopPropagation()
                }}
              />
            </Dropdown>
          </div>
        )}
      </td>
    </tr>
  )
}

const FileList = ({
  isFolder,
  folders,
  files,
  selectedItems,
  onSelectionChange,
  onAction,
  user,
  orgUserList,
  defaultQuery,
  userId,
  isSuperAdmin,
  isAdmin,
  aiProcessingItems,
  setVersionFile,
  setVersionModalVisible,
  setManagePermissionsModalVisible,
  setAuitModal,
  hoveredItemId,
  setHoveredItemId,
  shouldShowCheckbox,
  isAllFoldersSelected,
  isIndeterminateFolders,
  handleSelectAllFolders,
  isAllFilesSelected,
  isIndeterminateFiles,
  handleSelectAllFiles,
  searchType,
  handleItemClick,
  isDownloadCenter
}) => {
  const [openDropdownId, setOpenDropdownId] = useState(null)

  const { t } = useTranslation()

  return (
    <div className="list-content">
      {/* Folders group */}
      {!searchType && isFolder && (
        <Fragment>
          <div className="group-label group-label-flex-gap">
            {selectedItems.length > 0 && (
              <input
                type="checkbox"
                checked={isAllFoldersSelected}
                ref={el => {
                  if (el) el.indeterminate = isIndeterminateFolders
                }}
                onChange={handleSelectAllFolders}
                className="group-checkbox"
              />
            )}
            <span>{t('v4:folders')}</span>
          </div>
          <div className="file-table-wrapper">
            {folders.length > 0 ? (
              <table className="file-table">
                <thead>
                  <tr>
                    <th style={{ width: 40 }}></th>
                    <th style={{ width: '350px' }}>{t('v4:folder_name')}</th>
                    <th style={{ width: 70 }}></th>
                    <th>{t('v4:owner')}</th>
                    <th>{t('v4:last_updated')}</th>
                    <th>{t('v4:action')}</th>
                  </tr>
                </thead>
                <tbody>
                  {folders.map(item => (
                    <TableRow
                      key={item.id}
                      item={item}
                      isSelected={selectedItems.includes(item.id)}
                      shouldShowCheckbox={shouldShowCheckbox}
                      onCheckboxChange={e => {
                        const newSelection = e.target.checked
                          ? [...selectedItems, item.id]
                          : selectedItems.filter(id => id !== item.id)
                        onSelectionChange && onSelectionChange(newSelection)
                      }}
                      onRowClick={() => handleItemClick(item, null)}
                      onMouseEnter={() => setHoveredItemId(item.id)}
                      onMouseLeave={() => setHoveredItemId(null)}
                      aiProcessingItems={aiProcessingItems}
                      user={user}
                      orgUserList={orgUserList}
                      defaultQuery={defaultQuery}
                      userId={userId}
                      isSuperAdmin={isSuperAdmin}
                      isAdmin={isAdmin}
                      onAction={onAction}
                      setVersionFile={setVersionFile}
                      setVersionModalVisible={setVersionModalVisible}
                      setManagePermissionsModalVisible={
                        setManagePermissionsModalVisible
                      }
                      setAuitModal={setAuitModal}
                      showActions={true}
                      isImage={isImage}
                      type="folder"
                      openDropdownId={openDropdownId}
                      setOpenDropdownId={setOpenDropdownId}
                      isDownloadCenter={isDownloadCenter}
                    />
                  ))}
                </tbody>
              </table>
            ) : (
              <table className="file-table">
                <tbody>
                  <tr>
                    <td
                      colSpan={6}
                      className="no-folders-found"
                      style={{ height: '120px', padding: 0 }}
                    >
                      <div
                        className="no-folders-found-inner"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%',
                          width: '100%'
                        }}
                      >
                        <Icon type="folder-open" className="folder-open-icon" />
                        <div>{t('v4:no_folders_found')}</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        </Fragment>
      )}
      {/* Files group as table */}
      {files.length > 0 && !isFolder && (
        <>
          <div
            className="group-label"
            style={{ display: 'flex', alignItems: 'center', gap: 8 }}
          >
            {selectedItems.length > 0 && (
              <input
                type="checkbox"
                checked={isAllFilesSelected}
                ref={el => {
                  if (el) el.indeterminate = isIndeterminateFiles
                }}
                onChange={handleSelectAllFiles}
                style={{
                  marginRight: 4,
                  width: '16px',
                  height: '16px',
                  cursor: 'pointer'
                }}
              />
            )}
            <span>{t('v4:files')}</span>
          </div>
          <div className="file-table-wrapper">
            <table className="file-table">
              <thead>
                <tr>
                  <th style={{ width: 40 }}></th>

                  <th style={{ width: '350px' }}>{t('audio:file_name')}</th>
                  <th style={{ width: 70 }}></th>
                  <th>{t('v4:owner')}</th>
                  <th>{t('v4:last_updated')}</th>
                  <th>{t('v4:action')}</th>
                </tr>
              </thead>
              <tbody>
                {files.map(item => (
                  <TableRow
                    key={item.id}
                    item={item}
                    isSelected={selectedItems.includes(item.id)}
                    shouldShowCheckbox={shouldShowCheckbox}
                    onCheckboxChange={e => {
                      e.stopPropagation()
                      const newSelection = e.target.checked
                        ? [...selectedItems, item.id]
                        : selectedItems.filter(id => id !== item.id)
                      onSelectionChange && onSelectionChange(newSelection)
                    }}
                    onRowClick={() => handleItemClick(item, null)}
                    onMouseEnter={() => setHoveredItemId(item.id)}
                    onMouseLeave={() => setHoveredItemId(null)}
                    aiProcessingItems={aiProcessingItems}
                    user={user}
                    orgUserList={orgUserList}
                    defaultQuery={defaultQuery}
                    userId={userId}
                    isSuperAdmin={isSuperAdmin}
                    isAdmin={isAdmin}
                    onAction={onAction}
                    setVersionFile={setVersionFile}
                    setVersionModalVisible={setVersionModalVisible}
                    setManagePermissionsModalVisible={
                      setManagePermissionsModalVisible
                    }
                    setAuitModal={setAuitModal}
                    showActions={true}
                    isImage={isImage}
                    type="file"
                    openDropdownId={openDropdownId}
                    setOpenDropdownId={setOpenDropdownId}
                    isDownloadCenter={isDownloadCenter}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}

export default FileList
